import { Button, Card, FormControl, Grid, InputLabel, MenuItem, Select, Typography } from '@mui/material';
// import MuiStack from '@mui/material/Stack';
import { useEffect, useState } from 'react';
import MuiTextField from '@mui/material/TextField';
import { LoadingButton } from '@mui/lab';
import { PropTypes } from 'prop-types';
import { useFormik } from 'formik';
import instance from '../../api/axiosRequest';
import openNotification from '../../components/notification';
// import { useNavigate } from 'react-router-dom';
// import rzlogo from '../../images/rzpay.png';
// import pplogo from '../../images/paypal-logo.png';
// import allServices from '../../_mock/services';

// const Stack = (props) => <MuiStack fullWidth direction="row" {...props} />;
const TextField = (props) => <MuiTextField fullWidth {...props} />;

const PaymentButton = ({ setPaymentMethod, ...rest }) => (
  <Button
    sx={{
      bgcolor: rest.selected ? 'primary' : 'gray',
      boxShadow: 'none',
    }}
    onClick={() => setPaymentMethod(rest.alt)}
    fullWidth
    variant="contained"
  >
    <img {...rest} alt={rest.alt} />
  </Button>
);

PaymentButton.propTypes = {
  selected: PropTypes.bool,
  setPaymentMethod: PropTypes.func,
  alt: PropTypes.string,
};

export default function Checkout() {
  // const navigate = useNavigate();

  // const [paymentMethod, setPaymentMethod] = useState('');
  const [loading, setLoading] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);

  useEffect(() => {
    const getBillingInfo = async () => {
      try {
        const { data } = await instance.get('/vendor/getBillingInfo');
        if (data.data) {
          formik.setValues(data.data);
          setIsUpdate(true);
        }
      } catch (error) {
        console.log(error);
      }
    };
    getBillingInfo();
  }, []);

  const formik = useFormik({
    initialValues: {
      firstname: '',
      lastname: '',
      email: '',
      address: '',
      country: '',
      city: '',
      pincode: '',
      companyname: '',
      street: '',
      gst: '',
    },
    onSubmit: async (values) => {
      try {
        setLoading(true);
        await instance.post('/vendor/addBillingInfo', values);
        openNotification({ message: 'Operation completed successfully', type: 'success' });
        setLoading(false);
      } catch (error) {
        setLoading(false);
        openNotification({ message: 'Operation not completed successfully', type: 'error' });
        console.log(error);
      }
    },
  });

  return (
    <div>
      <Typography variant="h6" color="gray">
        Your billing information may be different from your account's profile information. Billing information appears
        in the invoices.
      </Typography>

      <Card sx={{ p: 4, maxWidth: 650 }}>
        <form onSubmit={formik.handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField id="country" label="Country" required name="country" {...formik.getFieldProps('country')} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                id="first-name"
                label="First Name"
                required
                name="firstname"
                {...formik.getFieldProps('firstname')}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                id="last-name"
                label="Last Name"
                required
                name="lastname"
                {...formik.getFieldProps('lastname')}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField id="email" label="Email" name="email" {...formik.getFieldProps('email')} />
            </Grid>
            <Grid item xs={12}>
              <TextField id="address" label="Address" required name="address" {...formik.getFieldProps('address')} />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField id="city" label="City" required name="city" {...formik.getFieldProps('city')} />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField id="gst" name="gst" label="Gst" {...formik.getFieldProps('gst')} />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField id="zip-code" label="Zip code" required name="pincode" {...formik.getFieldProps('pincode')} />
            </Grid>
            <Grid item xs={12}>
              <TextField
                id="companyname"
                label="Company Name"
                required
                name="companyname"
                {...formik.getFieldProps('companyname')}
              />
            </Grid>
            <br />
            {/* <Typography variant="h6">NAME OF SERVICES</Typography>
            <Grid item xs={12}>
              <FormControl fullWidth>
                <InputLabel id="services-select-label">Services</InputLabel>
                <Select
                  labelId="services-select-label"
                  id="services-select"
                  value={formik.values.service}
                  label="Services"
                  onChange={(e) => {
                    const val = e.target.value;
                    const service = val;
                    const amount = Number(val.split('-')[1]);
                    formik.setValues({ ...formik.values, service, amount });
                  }}
                >
                  {allServices.map((e) => (
                    <MenuItem key={e.name} value={`${e.name}-${e.price}`}>
                      {e.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <br />
            <Typography variant="h6">AMOUNT AND TAXES</Typography>
            <Grid item xs={12}>
              <TextField id="amount" disabled required name="amount" {...formik.getFieldProps('amount')} />
            </Grid>
            <Grid item xs={12}>
              <Stack justifyContent="space-between">
                <p>Taxes</p>
                <p>{formik.values.amount * 0.18}</p>
              </Stack>
            </Grid>
            <Grid item xs={12}>
              <Stack justifyContent="space-between">
                <p>Total</p>
                <p>{formik.values.amount * 0.18 + formik.values.amount}</p>
              </Stack>
            </Grid>
          </Grid>
          <Typography variant="h6">PAYMENT MODE</Typography>
          <MuiStack spacing={2}>
            <PaymentButton
              setPaymentMethod={setPaymentMethod}
              src={rzlogo}
              width={96}
              alt="razorpay"
              selected={paymentMethod === 'razorpay'}
            />
            <PaymentButton
              setPaymentMethod={setPaymentMethod}
              src={pplogo}
              height={20}
              alt="paypal"
              selected={paymentMethod === 'paypal'}
            />
            <Button fullWidth onClick={() => navigate('/dashboard/success')} variant="contained">
              PROCEED TO PAYMENT
            </Button>
          </MuiStack> */}
          </Grid>
          <LoadingButton sx={{ mt: 2 }} type="submit" loading={loading} variant="contained">
            {isUpdate ? 'Update' : 'Submit'}
          </LoadingButton>
        </form>
      </Card>
    </div>
  );
}
